import { render, staticRenderFns } from "./LanguagePopup.vue?vue&type=template&id=856095a2&scoped=true"
import script from "./LanguagePopup.vue?vue&type=script&lang=js"
export * from "./LanguagePopup.vue?vue&type=script&lang=js"
import style0 from "./LanguagePopup.vue?vue&type=style&index=0&id=856095a2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_c18e9a749cc21ff970a79c65ca01237d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "856095a2",
  null
  
)

export default component.exports